import { UserXIcon } from 'lucide-react';
import type { FC } from 'react';
import { useAppStateMachine } from '../../../components/providers/app-state-machine-provider.tsx';
import { Button } from '../../../components/ui/button.tsx';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../components/ui/tooltip.tsx';
import { useAppState } from '../../../lib/hooks/use-app-state.ts';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { getFullName } from '../../../utils/name.ts';

type ImpersonationBannerProps = {
    expanded?: boolean;
};

export const ImpersonationBanner: FC<ImpersonationBannerProps> = ({ expanded = true }) => {
    const { t } = useLocale('common');
    const { state, send } = useAppStateMachine();
    const { platoUser } = useAppState();

    if (!state.matches('IMPOERSONATION_SESSION')) {
        return null;
    }

    const exitImpersonation = () => {
        send({ type: 'END_IMPERSONATING_SESSION' });
    };

    const fullName = getFullName(platoUser?.firstName, platoUser?.lastName);
    const customerName = platoUser?.platoCustomer.name;
    const buttonLabel = `${customerName ?? ''}${fullName ? ` (${fullName})` : ''}`;

    if (expanded) {
        return (
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        variant="ghost"
                        onClick={exitImpersonation}
                        leftIcon={UserXIcon}
                        className="w-full min-w-0 justify-start [&>svg]:shrink-0"
                        aria-label={t('exit_demo__button')}
                    >
                        <span className="truncate font-normal">{buttonLabel}</span>
                    </Button>
                </TooltipTrigger>
                <TooltipContent side="right">{t('exit_demo__button')}</TooltipContent>
            </Tooltip>
        );
    }

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button
                    variant="ghost"
                    onClick={exitImpersonation}
                    icon={UserXIcon}
                    aria-label={t('exit_demo__button')}
                />
            </TooltipTrigger>
            <TooltipContent side="right">{buttonLabel}</TooltipContent>
        </Tooltip>
    );
};
